import React from 'react';
import PropTypes from 'prop-types';
import RequiredReasonTextarea from '../../../util_components/required_reason_textarea';

// The Edit modal's required note, worded for a status change or a who-cancelled flip; hidden when none is needed.
function EditReasonField({ edit, value, name, onChange, error }) {
  if (!edit.show_reason_textarea) return null;
  return (
    <RequiredReasonTextarea
      value={value}
      name={name}
      onChange={onChange}
      placeholder={
        edit.status_changed
          ? 'Reason for status change (required)'
          : 'Reason for changing who cancelled (required)'
      }
      error={error}
      errorText={
        edit.status_changed
          ? 'A reason (at least 3 characters) is required to change the session status'
          : 'A reason (at least 3 characters) is required to change the cancellation attribution'
      }
    />
  );
}

EditReasonField.propTypes = {
  edit: PropTypes.shape({
    show_reason_textarea: PropTypes.bool,
    status_changed: PropTypes.bool
  }).isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool
};

EditReasonField.defaultProps = {
  value: '',
  error: false
};

export default EditReasonField;
